import { Container, Grid, Typography } from "@mui/material";
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { makeStyles } from "@mui/styles";
import { CardActionArea } from "@mui/material";

const useStyles = makeStyles(() => {
  return {
    typoText: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
    },
    typoTextRight: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
      textAlign: "right",
    },
    typoHeadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 700,
      //   fontSize: 60,
    },
  };
});

const Section2 = () => {
  const classes = useStyles();

  return (
    <>
      <Container
        sx={{ paddingTop: 20 }}
        id="about"
        data-aos="fade-up"
        data-aos-offset="250"
        data-aos-duration="800"
      >
        <Grid container direction="row" justifyContent="center">
          <Grid item>
            <Card sx={{ maxWidth: 700 }} elevation={0}>
              <CardContent>
                <img src="fr.svg" height="100%" width="100%" />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={12} md={6}>
            <Card elevation={0}>
              <CardContent>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <img src="logo1.png" height="70%" width="70%" />
                  </Grid>
                  <Grid item xs={10} sx={{ padding: 2 }}>
                    <Typography className={classes.typoText} variant="h6">
                      I develop optimized Websites and Webapps
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <img src="logo2.png" height="70%" width="70%" />
                  </Grid>
                  <Grid item xs={10} sx={{ padding: 2 }}>
                    <Typography className={classes.typoText} variant="h6">
                      Build a responsive frontend
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container alignItems="center">
                  <Grid item xs={2}>
                    <img src="logo3.png" height="70%" width="70%" />
                  </Grid>
                  <Grid item xs={10} sx={{ padding: 2 }}>
                    <Typography className={classes.typoText} variant="h6">
                      Choose a technology stack based on your organization needs
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card elevation={0}>
              <CardContent>
                <Grid container alignItems="center">
                  <Grid item xs={10} sx={{ padding: 2 }}>
                    <Typography className={classes.typoTextRight} variant="h6">
                      I create customized Web designs based on your content
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <img src="logo4.png" height="70%" width="70%" />
                  </Grid>
                </Grid>
                <Grid container alignItems="center">
                  <Grid item xs={10} sx={{ padding: 2 }}>
                    <Typography className={classes.typoTextRight} variant="h6">
                      Design Sitemaps and wireframes for interpreting webflows
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <img src="logo5.png" height="70%" width="70%" />
                  </Grid>
                </Grid>
                <Grid container alignItems="center">
                  <Grid item xs={10} sx={{ padding: 2 }}>
                    <Typography className={classes.typoTextRight} variant="h6">
                      Revamp an existing structure to provide best user
                      experience
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <img src="logo6.png" height="70%" width="70%" />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Section2;
